import { render, staticRenderFns } from "./AdditionalFieldViewItem.vue?vue&type=template&id=8e8eb194"
import script from "./AdditionalFieldViewItem.vue?vue&type=script&lang=js"
export * from "./AdditionalFieldViewItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports